import plutioProvider from "../../providers/prod/plutio";
import {
	AddOn,
	AddOnPlan,
	AddOnStatus,
	AddOnType,
	Asset,
	BillingCycle,
	Currency,
	HighlightFeature,
	Price,
	SettingsConfig,
	SettingsConfigType,
	UsageStats,
	UsageStatsType,
} from "../../../../index";

const a013AddOn = new AddOn({
	internalId: "a013",
	externalId: "pro_01kysg4mvd735bs7thy49j7tpa",
	shortName: "Plutio Credits",
	longName: "Plutio Credits",
	shortDescription: "Track prepaid Plutio credits from invoices through time entry usage.",
	longDescription:
		"Connect a Plutio project to turn invoice line items into prepaid credit buckets, consume those credits from time entries, and keep project stakeholders informed when balances run low.",
	type: AddOnType.SERVICE,
	iconAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a013/icons/a013_icon_rounded.png"
	),
	coverAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/background1.png"
	),
	previewAssets: [],
	docsUrl: "",
	providersIds: [plutioProvider._.id],
	status: AddOnStatus.ACTIVE,
	plans: [
		new AddOnPlan({
			billingCycle: BillingCycle.yearly(),
			internalId: "a013_p001",
			externalId: "pri_01kysg7mxxsazjqy8wa81jjtyt",
			prices: [new Price({ currency: Currency.USD, amount: 14 })],
		}),
		new AddOnPlan({
			billingCycle: BillingCycle.monthly(),
			internalId: "a013_p002",
			externalId: "pri_01kysg92ejrepvymp2hsf974xw",
			prices: [new Price({ currency: Currency.USD, amount: 2 })],
		}),
	],
	usageStats: [
		new UsageStats({
			id: "credit_buckets",
			name: "Credit buckets",
			description: "Invoice-backed prepaid credit buckets tracked for Plutio projects.",
			type: UsageStatsType.DOCUMENTS,
		}),
		new UsageStats({
			id: "time_entries",
			name: "Time entries synced",
			description: "Plutio time entries processed against available credits.",
			type: UsageStatsType.REQUESTS,
		}),
	],
	settingsConfig: [
		new SettingsConfig({
			id: "plutio_integration",
			label: "Plutio workspace",
			description: "Select the connected Plutio workspace used for credits, invoices, and time entries.",
			type: SettingsConfigType.INTEGRATION,
			validators: "plutio",
			required: true,
		}),
	],
	highlightFeatures: [
		new HighlightFeature({
			title: "Invoice-backed credits",
			description: "Create prepaid credit buckets from marked Plutio invoice items.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/file-text.svg",
		}),
		new HighlightFeature({
			title: "Usage allocation",
			description: "Apply project time entries to available credits with configurable overage handling.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/repeat.svg",
		}),
	],
});

export default a013AddOn;
